<template>
  <ul class="c-topics">
    <li class="c-topics__item" v-for="(topic, key) in items" :key="key">
      <topic-circle
        :label="topic.title"
        :to="'trend/' + key"
        :status="readyForTopic(key)"
        :size="sizeCategory(key)"
        :no-opinion="hasNoOpinion(key)"
        :image="'/images/' + topic.image"
      />
      <button
        class="toggle-no-opinion"
        v-if="showButtons"
        @click.prevent="toggleNoOpinion(key)"
      >{{ hasNoOpinion(key) ? '+': 'x' }}</button>
    </li>
  </ul>
</template>

<script>
import topicMixins from "../mixins/Topics.js";
import TopicCircle from "../components/TopicCircle.vue";
export default {
  mixins: [topicMixins],
  components: { TopicCircle },
  props: ["items", "showButtons"]
};
</script>

<style lang="scss">
@import "../assets/styles/variables.scss";

.c-topics {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding: 0;
}

.c-topics .c-topics__item {
  position: relative;
  margin: 1.2rem;
}

.c-topics .c-topics__item .toggle-no-opinion {
  z-index: 3;
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  cursor: pointer;
}

@media (max-width: $bp-medium) {
  .c-topics__item {
    margin: 0.8rem;
  }
}
</style>
